module.exports = __webpack_public_path__ + "static/media/splash-loader.dac4a1f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/Loader/splash-loader.svg
// module id = 152
// module chunks = 0